"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("ant-select", _vm._g({
    attrs: {
      options: _vm.renderOptions,
      "filter-option": false,
      "show-search": "",
      "show-arrow": "",
      loading: _vm.loading,
      placeholder: _vm.placeholder,
      mode: _vm.mode,
      "max-tag-text-length": 5,
      "max-tag-count": 1,
      "allow-clear": true,
      "get-popup-container": _vm.getPopupContainer
    },
    on: {
      search: _vm.handleSearch,
      popupScroll: _vm.handleScroll,
      change: _vm.handleChange,
      dropdownVisibleChange: _vm.handleDropdownVisibleChange
    },
    model: {
      value: _vm.selectedValue,
      callback: function ($$v) {
        _vm.selectedValue = $$v;
      },
      expression: "selectedValue"
    }
  }, _vm.events), [_vm._t("default", null, null, {
    options: _vm.options
  })], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;